 // API Configuration
 import { Config } from "../../Common/Config";
 const API_BASE_URL = Config.url;
 export const API_CONFIG = {
   baseUrl: API_BASE_URL,
   getAuthHeader: () => ({
     'Authorization': `Bearer ${localStorage.getItem('token')}`,
     'Content-Type': 'application/json',
   }),
 };
 
 // Email Configurations API
 export const emailConfigApi = {
   // Fetch all email configurations
   async getAll() {
     const response = await fetch(`${API_CONFIG.baseUrl}email-configurations`, {
       method: 'GET',
       headers: API_CONFIG.getAuthHeader(),
     });
     
     if (!response.ok) {
       throw new Error('Failed to fetch email configurations');
     }
     
     const data = await response.json();
     return data.data;
   },
 
   // Update email configuration by ID
  async update(id, payload) {
    const response = await fetch(`${API_CONFIG.baseUrl}email-configurations/${id}`, {
       method: 'PUT',
       headers: API_CONFIG.getAuthHeader(),
       body: JSON.stringify(payload),
     });
     
     if (!response.ok) {
       throw new Error('Failed to update email configuration');
     }
     
     return response.json();
   },
 };
 
 // Shortcodes API
 let shortcodeCache = null;
 
 export const shortcodesApi = {
   async getAll() {
     if (shortcodeCache) {
       return shortcodeCache;
     }
     
     const response = await fetch(`${API_CONFIG.baseUrl}short-codes`, {
       method: 'GET',
       headers: API_CONFIG.getAuthHeader(),
     });
     
     if (!response.ok) {
       throw new Error('Failed to fetch shortcodes');
     }
     
     const data = await response.json();
     shortcodeCache = data.data;
     return shortcodeCache;
   },
   
   clearCache() {
     shortcodeCache = null;
   },
 };